
function myFunction() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    ul = document.getElementById("myUL");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
}
/*jQuery(document).ready(function () {
   
   jQuery('#hit').click(function() {
     var get = $("#gsearch").val();
     var get1 = '"';
     var get2 =get1+get+get1;

     if(get !== null && get !== '') {
     window.location.href = "https://121remotecontrols.myshopify.com/search?q="+get2;
       } else {
greeting = "Please Enter Model Number";
}
  document.getElementById("demo").innerHTML = greeting;   
  });
  });
*/
jQuery(document).ready(function () {
   
   jQuery('#hit').click(function() {
     var get = $("#gsearch").val();
     // var get2 = $("#gsearch2").val();
     var get2 = document.getElementById("ddlViewBy");
     var strUser = get2.value;
     var colon = ':';
     var find = strUser+colon+get
    // alert(total);
     if(get !== null && get !== '') {
        window.location.href = "https://121remotecontrols.myshopify.com/search?q="+find;
    // window.location.href = "https://121remotecontrols.myshopify.com/search?q=tag:"+find;
       } else {
greeting = "Please Enter Model Number";
}
  document.getElementById("demo").innerHTML = greeting;   
  });
  });